import { render, staticRenderFns } from "./5.vue?vue&type=template&id=77f1aa5e&scoped=true&"
var script = {}
import style0 from "./5.vue?vue&type=style&index=0&id=77f1aa5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f1aa5e",
  null
  
)

export default component.exports